/* DubaiCrystal — premium motion layer
   Small, dependency-free. Everything respects prefers-reduced-motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var docEl = document.documentElement;
  docEl.classList.add('dc-js');

  /* 1. Reveal on scroll: .dc-reveal and [data-dc-stagger] > children */
  function setupReveal() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('.dc-reveal, .dc-neon, .dc-iwt'));
    var lines = document.querySelectorAll('.title-wrapper-with-link .title, .collection__title .title, .collection-list-title, .product-recommendations__heading');
    lines.forEach(function (t) { t.classList.add('dc-line'); targets.push(t); });
    document.querySelectorAll('[data-dc-stagger]').forEach(function (wrap) {
      var i = 0;
      Array.prototype.forEach.call(wrap.children, function (child) {
        child.classList.add('dc-reveal');
        child.style.setProperty('--dc-delay', Math.min(i * 70, 560) + 'ms');
        i++;
        targets.push(child);
      });
    });
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-visible', 'dc-line-on'); if (t.classList.contains('dc-iwt')) t.classList.add('dc-iwt--on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); if (e.target.classList.contains('dc-iwt')) e.target.classList.add('dc-iwt--on'); if (e.target.classList.contains('dc-line')) e.target.classList.add('dc-line-on'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* 2. Images fade in softly as they load */
  function setupImages() {
    if (reduce) return;
    var imgs = document.querySelectorAll('.card__media img, .image-with-text__media img, .collection-list img');
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) { img.classList.add('dc-img-loaded'); return; }
      img.classList.add('dc-img-pending');
      img.addEventListener('load', function () { img.classList.add('dc-img-loaded'); img.classList.remove('dc-img-pending'); }, { once: true });
      img.addEventListener('error', function () { img.classList.remove('dc-img-pending'); }, { once: true });
    });
  }

  /* 3. Gentle parallax on the hero slideshow media (desktop only) */
  function setupParallax() {
    if (reduce || window.innerWidth < 990) return;
    var slides = document.querySelectorAll('.slideshow .banner__media img, .dc-editorial__media, .dc-hero__img, .dc-hero__video');
    if (!slides.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      slides.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var progress = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight; // -1..1
        var y = Math.max(-1, Math.min(1, progress)) * -28;
        el.style.setProperty('--dc-parallax', y.toFixed(2) + 'px');
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* 4. Soft cursor-follow tilt on product cards (very subtle, desktop with a mouse) */
  function setupTilt() {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('mousemove', function (e) {
      var card = e.target.closest && e.target.closest('.product-card-wrapper .card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--dc-tilt-x', (y * -2.5).toFixed(2) + 'deg');
      card.style.setProperty('--dc-tilt-y', (x * 2.5).toFixed(2) + 'deg');
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.product-card-wrapper .card');
      if (card && !card.contains(e.relatedTarget)) {
        card.style.setProperty('--dc-tilt-x', '0deg');
        card.style.setProperty('--dc-tilt-y', '0deg');
      }
    }, { passive: true });
  }

  /* 5. Thin gold scroll-progress line under the header */
  function setupProgress() {
    if (reduce) return;
    var bar = document.createElement('div');
    bar.className = 'dc-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      ticking = false;
      var h = docEl.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(1, window.scrollY / h) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }


  /* 6. Floating crystal hero: pieces follow the cursor and the scroll by depth */
  function setupFloat() {
    var heroes = document.querySelectorAll('[data-dc-float]');
    if (!heroes.length || reduce) return;
    heroes.forEach(function (hero) {
      var pieces = hero.querySelectorAll('.dc-fh__piece');
      var strength = parseFloat(hero.getAttribute('data-strength') || '30');
      var tx = 0, ty = 0, cx = 0, cy = 0, scrollY = 0, raf = null;
      function render() {
        raf = null;
        cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
        pieces.forEach(function (p) {
          var d = parseFloat(p.getAttribute('data-depth') || '2');
          var k = d / 3;
          var px = cx * strength * k;
          var py = cy * strength * k + scrollY * (0.25 + k * 0.35);
          p.style.setProperty('--px', px.toFixed(2) + 'px');
          p.style.setProperty('--py', py.toFixed(2) + 'px');
        });
        if (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) raf = requestAnimationFrame(render);
      }
      function kick() { if (!raf) raf = requestAnimationFrame(render); }
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
          ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
          kick();
        }, { passive: true });
        hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; kick(); });
      }
      window.addEventListener('scroll', function () {
        var r = hero.getBoundingClientRect();
        if (r.bottom < 0) return;
        scrollY = Math.max(0, -r.top) * 0.35;
        kick();
      }, { passive: true });
      if (window.DeviceOrientationEvent && !window.matchMedia('(hover: hover)').matches) {
        window.addEventListener('deviceorientation', function (e) {
          if (e.gamma == null) return;
          tx = Math.max(-1, Math.min(1, e.gamma / 30));
          ty = Math.max(-1, Math.min(1, (e.beta - 45) / 30));
          kick();
        }, { passive: true });
      }
    });
  }


  /* 7. Product gallery: minimal prev/next arrows over the main image (desktop) */
  function setupGalleryArrows() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      var list = gallery.querySelector('.product__media-list');
      if (!viewer || !list || viewer.querySelector('.dc-gal')) return;
      var items = function () { return Array.prototype.slice.call(list.querySelectorAll(':scope > li.product__media-item[data-media-id]')); };
      if (items().length < 2) return;
      /* the theme's own scroll-reveal fires the moment a hidden slide is shown (a white flash) — strip it from gallery slides */
      list.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--fade-in', 'animate--slide-in'); });
      /* make sure every gallery image is actually loaded, since hidden slides lazy-load */
      list.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; if (img.dataset.src && !img.src) img.src = img.dataset.src; });
      var wrap = document.createElement('div');
      wrap.className = 'dc-gal';
      wrap.innerHTML =
        '<button type="button" class="dc-gal__btn dc-gal__btn--prev" aria-label="Previous image"><svg viewBox="0 0 16 32" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 16l10 14"/></svg></button>' +
        '<button type="button" class="dc-gal__btn dc-gal__btn--next" aria-label="Next image"><svg viewBox="0 0 16 32" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2l10 14L3 30"/></svg></button>' +
        '<div class="dc-gal__count"><span class="dc-gal__cur">1</span><i></i><span class="dc-gal__tot">' + items().length + '</span></div>';
      viewer.appendChild(wrap);
      var cur = wrap.querySelector('.dc-gal__cur');
      function current() { var all = items(); var i = all.findIndex(function (el) { return el.classList.contains('is-active'); }); return i < 0 ? 0 : i; }
      var busy = false;
      function show(i, dir) {
        var all = items(); var target = all[i]; var id = target.getAttribute('data-media-id');
        var from = all[current()];
        if (busy || from === target) return;
        busy = true;
        var cls = dir < 0 ? 'dc-dir-prev' : 'dc-dir-next';
        list.classList.add('dc-animating');
        all.forEach(function (el) { el.classList.remove('is-active'); });
        from.classList.add('dc-leaving', cls);
        target.classList.add('is-active', 'dc-entering', cls);
        setTimeout(function () {
          from.classList.remove('dc-leaving', 'dc-dir-prev', 'dc-dir-next');
          target.classList.remove('dc-entering', 'dc-dir-prev', 'dc-dir-next');
          list.classList.remove('dc-animating');
          busy = false;
        }, 680);
        /* sync the thumbnail strip without scrolling the page */
        var thumbs = gallery.querySelectorAll('[data-target]');
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        var thumb = gallery.querySelector('[data-target="' + id + '"]');
        if (thumb) {
          thumb.setAttribute('aria-current', 'true');
          var li = thumb.closest('li'); var track = li && li.parentElement;
          if (li && track && track.scrollWidth > track.clientWidth) {
            track.scrollTo({ left: li.offsetLeft - (track.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
          }
        }
        var media = from.querySelector('deferred-media, product-model'); if (media && media.pause) media.pause();
        cur.textContent = i + 1;
      }
      function go(dir) { var n = items().length; show((current() + dir + n) % n, dir); }
      wrap.querySelector('.dc-gal__btn--prev').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
      wrap.querySelector('.dc-gal__btn--next').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
      gallery.addEventListener('click', function (e) { if (e.target.closest('[data-target]')) setTimeout(function () { cur.textContent = current() + 1; }, 60); });
      document.addEventListener('keydown', function (e) {
        if (e.target.matches('input, textarea, select') || document.querySelector('.product-media-modal[open]')) return;
        var r = viewer.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
        if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1);
      });
    });
  }


  function init() {
    setupReveal();
    setupImages();
    setupParallax();
    setupTilt();
    setupProgress();
    setupFloat();
    setupGalleryArrows();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Re-run reveal for content injected by the theme editor / section rendering API */
  document.addEventListener('shopify:section:load', function () { setupReveal(); setupImages(); setupGalleryArrows(); });
})();
